import React from 'react';
import styled from 'styled-components'; 
import { Grid, Row } from 'react-bootstrap';
import TimeColoredCenteredCol from './TimeColoredCenteredCol';
import Job from './Job';

const PaddedCol = styled(TimeColoredCenteredCol)`
    padding: 20px 0 20px 0;
`;

const games = require('../../games.json');

const jobsList = (props) => {
    return (
        <Grid fluid>
            <Row>
                <PaddedCol xs={12} isDay={props.isDay}>
                    <h1>{props.isDay ? 'Day Job' : 'Night Job'}</h1>
                </PaddedCol>
            </Row>
            {games.filter(game => props.isDay ? game.isDayJob : !game.isDayJob).map(game => 
                <Row key={game.id}><TimeColoredCenteredCol xs={12} isDay={props.isDay}><Job isDay={props.isDay} {...game} clicked={props.clicked}/></TimeColoredCenteredCol></Row>)
            }
        </Grid>
    );
};

export default jobsList;


// WEBPACK FOOTER //
// ./src/components/Job/JobsList.js